import request from '@/utils/request'

// 查询维修材料分类列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/material/page',
        method: 'get',
        params: query,
    })
}
// 查询维修材料分类详细
export function getObj(id) {
    return request({
        url: '/upkeep/material/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修材料分类
export function addObj(data) {
    return request({
        url: '/upkeep/material/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用状态
export function statusObj(data) {
    return request({
        url: '/upkeep/material/status',
        method: 'post',
        data: data,
    })
}
// 修改维修材料分类
export function putObj(data) {
    return request({
        url: '/upkeep/material/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修材料分类
export function delObj(data) {
    return request({
        url: '/upkeep/material/delete',
        method: 'post',
        data: data,
    })
}
